<template>
  <div>
    <AppCardDashboardLoading v-if="loading" />
    <app-card-dashboard
      v-else
      content
      overline="Pendências"
      title="Revisão de documentos"
      description="Verifique os documentos listados abaixo e informe os dados pendentes."
    >
      <v-list>
        <app-item-pendencias
          v-for="(item, index) in listOfPendencies"
          :key="index"
          :data="item"
        />
      </v-list>
    </app-card-dashboard>
  </div>
</template>

<script>
import Store from '@/store'
import pendencias from '../util/pendencies'
import AppCardDashboard from '@/components/AppCardDashboard'
import AppCardDashboardLoading from '@/components/AppCardDashboardLoading'
import AppItemPendencias from '@/components/AppItemPendencias'
import { mapActions } from 'vuex'
export default {
  components: {
    AppCardDashboard,
    AppCardDashboardLoading,
    AppItemPendencias
  },
  data () {
    return {
      listOfPendencies: [],
      loading: true
    }
  },
  async created () {
    this.listOfPendencies = pendencias
    await this.getPendencias()
  },
  methods: {
    ...mapActions(['getDashboardData']),
    async getPendencias () {
      await this.getDashboardData()
      this.loading = false
    }
  },
  mounted () {
    Store.watch((state, getters) => getters['onlyTecnico'], async (val) => {
      this.loading = true
      await this.getPendencias()
    })
  }
}
</script>
